import React from 'react';
import {
	Grid,
	Box,
	Button,
	Typography
} from '@mui/material';
import {
	useModalContext,
	useCalculatorContext,
	useSnackbarContext
} from '../../utilities';

export const DeleteConditionPrompt = ({ condition, index }) => {
	const { closeModal } = useModalContext();
	const { showSnackbar } = useSnackbarContext();
	const { update, setUpdate, deleteCondition } = useCalculatorContext();

	const handleDelete = async () => {
		let res = await deleteCondition(condition);
		if (res && res.status === 200) {
			showSnackbar('Condition deleted', 'success');
			setUpdate(!update);
		} else {
			showSnackbar('Error - Condition NOT deleted', 'error');
		}
		closeModal();
	};

	return (
		<Box>
			<Grid container justifyContent='center' spacing={2}>
				<Grid item xs={12} textAlign='center'>
					<Typography>Do you want to permanently delete condition <b>{index + 1}</b>?</Typography>
				</Grid>
				<Grid item>
					<Button variant='contained' color='warning' onClick={handleDelete}>delete</Button>
				</Grid>
				<Grid item>
					<Button variant='contained' onClick={closeModal}>cancel</Button>
				</Grid>
			</Grid>
		</Box>
	);
};